import React,{useState, useEffect} from 'react';
import './EQTest.css'
import axios from 'axios';
import {Slider,Spin} from 'antd'
import "antd/dist/antd.css"
import {HiDownload} from 'react-icons/hi'
import {FaArrowAltCircleRight} from 'react-icons/fa'
import Graph from '../../Graph/Graph';
import jsPDF from 'jspdf'
import { db } from '../../../../config/firebase'
import firebase from "firebase";
import {BsCheckCircleFill} from 'react-icons/bs'


const url = "https://totalappi.herokuapp.com/test5/questions";

const user = sessionStorage.getItem('user')

const EQTest = () => {
    const [current,setCurrent] = useState(0)
    const [result,setResult] = useState(false)
    const [loading,setLoading] = useState(false)
    const [questions,setQuestions] = useState([]);
    const [answers,setAnswers] = useState([])

    useEffect(()=>{
        window.scrollTo(0,0)
    },[])

    const getQuestions = async () =>{
        axios.get(url)
        .then(res=>{
            let data = res.data.questions
            setQuestions(data)
        })
        .catch(err=>{
            console.log(err)
        })
    }

    useEffect(()=>{
        getQuestions();
    },[])


    const moveNext = () => {
        setCurrent(current+1)
        console.log(value)
        setAnswers([...answers,value])

        if(current==questions.length-1){
            submit()
        }    

        // if(current==4){
        //     submit()
        // } 
    }

    const arr = {
        '0':'',
    }
       
    const [graphData,setGraphdata] = useState([])


    const submit = () => {
        let param = answers.join(" ")
        console.log(param)

        setLoading(true)

        axios({
            method: "GET",
            url: 'https://totalappi.herokuapp.com/test5/answers'+'/'+param,
        })
        .then(res => {
            let graph = res.data.Score
            let attribute = res.data.Attribute
            let analysis = res.data.Analysis
            setGraphdata([graph,attribute,analysis])

            console.log(res.data)

            db.collection("contacts").doc(user).update({
                result: firebase.firestore.FieldValue.arrayUnion({'eq':res.data})
            })
            .then(()=>{
                console.log('result added to document')
            })
            .catch(err=>{
                console.log(err)
            })

            setResult(true)
            setLoading(false)
        })
        .catch(err => {
            console.log(err)
        })
    }


    const [value,setValue] = useState(1)

    const changeValue = (value) => {
        console.log(value)
        setValue(value)
    }


    const downloadPdf = () => {
        var doc = new jsPDF(),
        margins = {

        }
        
        doc.addFont('Poppins','normal','normal')
        doc.text('RESULT', doc.internal.pageSize.width, 50, null, null, 'center')

        doc.text(20,60,graphData[1])

        {
            let analysis = graphData[2]

            doc.text(20,80,"BRIEF")
            doc.text(20,100,analysis.Brief)
        }

        // {
        //     let analysis = graphData[2]
        //     let emotions = analysis.EMotions

        //     doc.text(20,110,"EMOTIONS")
        //     for(let i=0; i<emotions.length; i++){
        //         doc.text(20,120,emotions[i])
        //     }
        // }


        doc.save('a.pdf')
    }

    const marks = {
        0: "NOT apply",
        1: "HALF the time",
        2: "ALWAYS applies"
    }


    return ( 
        <>
        {/* {
            result &&
            <div style={{position:'absolute',right:'10vw',top:'25vh'}}>
                <div className='download-button' onClick={downloadPdf}>
                    <HiDownload size={20}/>
                    <div>Download</div>
                </div>
            </div>
        } */}
        <div className='aptitude-container'>

            {
                loading &&
                <div style={{textAlign:'center'}}>
                    <Spin size='large'/>
                    <div>Submitting for test</div>
                </div>
            }
            {
                result ?
                // <h3 className='test-submitted'>
                //     <Graph graphData={graphData}/>
                // </h3>
                <div style={{textAlign:'center'}}>
                    <BsCheckCircleFill color='green' size='30px'/>
                    <div>Test submitted successfully</div>
                </div>
                :
                <>
                {
                    questions ?
                    <div>
                        <div className='question-no'>Question {current+1}.</div>
                        <h4 className='question'>{questions[current]}</h4>
                        <Slider marks={marks} onChange={changeValue} defaultValue={value} min={0} max={2} tooltipVisible style={{width:'50%',margin:'10vh auto'}} />
                        
                        {
                            value===''?
                            <div className='next-container'>
                                {
                                    current===questions.length-1 ? <>Finish</> : <>Next</>
                                    // current===4 ? <>Finish</> : <>Next</>
                                }
                                <FaArrowAltCircleRight className='disabled'/>
                            </div>
                            :
                            <div onClick={moveNext} className='next-container'>
                                {
                                    current===questions.length-1 ? <>Finish</> : <>Next</>
                                    // current===4 ? <>Finish</> : <>Next</>
                                }
                                <FaArrowAltCircleRight className='active'/>
                            </div>
                        }
                    </div>
                    :
                    <h3 className='test-loader'>
                        <Spin size='large'/>
                        <div>loading test</div>
                    </h3>
                }
                </>
            }
        </div>
        </>
     );
}
 
export default EQTest;